import React from "react";
import { DPRestrictedPage } from "Components/DP";
import { PageNotFound } from "..";
import { usePayrollAnomalies } from "Hooks/usePayrollAnomalies";
import { AnomalyReport } from "./AnomalyReport/AnomalyReport";

const AnomalyReportPage = () => {
  const { disablePayrollAnomaly } = usePayrollAnomalies();

  if (disablePayrollAnomaly) {
    return (
      <PageNotFound />
    );
  }

  return (
    <DPRestrictedPage title="Anomaly Report" permissionKey="canViewDataExchange">
      <AnomalyReport />
    </DPRestrictedPage>
  );
};

export default AnomalyReportPage;
